<div class="flex-column gap-L">
	<div class="flex-align-center gap-S">
		<div class="font-MM fw-700">{{ 'page.appDetails.overview.informations'|translate }}</div>
		<img src="assets/icons/check-circle-green.svg" height="14px" alt="">
	</div>
	<div class="flex-column">
		<div class="flex-align-center border-light-grey-top" style="height: 50px;">
			<div class="flex-align-center pad-S w-50 border-box">
				<div class="flex-align-center gap-XS w-50">
					<img class="filter-grey" src="assets/icons/building.svg" height="14px" alt="">
					<span class="font-M fw-500 grey">{{ 'page.workstation.manufacturer' | translate }}</span>
				</div>
				<div class="flex-align-center w-50">
					<div [tooltip]="workstation.manufacturer || 'page.workstation.noData' | translate" [tooltipDisabled]="workstation.manufacturer !== null && !isEllipsisActive(manufacturer)" [tooltipOffset]="5" class="info-chip flex-space-between flex-align-center">
						<span #manufacturer class="text-overflow-ellipsis">{{ workstation.manufacturer || '-' }}</span>
					</div>
				</div>
			</div>
			<div class="border-light-grey-left" style="height: 25px"></div>
			<div class="flex-align-center pad-S w-50 border-box">
				<div class="flex-align-center gap-XS w-50">
					<img class="filter-grey" src="assets/icons/container.svg" height="14px" alt="">
					<span class="font-M fw-500 grey">{{ 'page.workstation.model' | translate }}</span>
				</div>
				<div class="flex-align-center w-50">
					<div  [tooltip]="workstation.workstationModel || 'page.workstation.noData' | translate" [tooltipDisabled]="workstation.workstationModel !== null && !isEllipsisActive(model)" [tooltipOffset]="5" class="info-chip flex-space-between flex-align-center">
						<span #model class="text-overflow-ellipsis">{{ workstation.workstationModel || '-' }}</span>
					</div>
				</div>
			</div>
		</div>
		<div class="flex-align-center border-light-grey-top" style="height: 50px;">
			<div class="flex-align-center pad-S w-50 border-box">
				<div class="flex-align-center gap-XS w-50">
					<img src="assets/icons/zap.svg" height="14px" alt="">
					<div class="flex-align-center">
						<span class="font-M fw-500 grey">{{ 'page.workstation.os' | translate }}</span>
					</div>
				</div>
				<div class="flex-align-center w-50">
					<div class="info-chip flex-space-between flex-align-center">
						<span class="text-overflow-ellipsis">{{ workstation.osModel + ' ' + workstation.osVersion }}</span>
					</div>
				</div>
			</div>
			<div class="border-light-grey-left" style="height: 25px"></div>
			<div class="flex-align-center pad-S w-50 border-box">
				<div class="flex-align-center gap-XS w-50">
					<img class="filter-grey" src="assets/icons/qr-code-01.svg" height="14px" alt="">
					<span class="font-M fw-500 grey">{{ 'page.workstation.serialNumber' | translate }}</span>
				</div>
				<div class="flex-align-center flex-space-between w-50">
					<div [tooltip]=" workstation.serialNumber || 'page.workstation.noData' | translate" [tooltipDisabled]="workstation.serialNumber !== null && !isEllipsisActive(serialNumber)" [tooltipOffset]="5" class="info-chip flex-space-between flex-align-center">
						<span #serialNumber class="text-overflow-ellipsis">{{ workstation.serialNumber || '-' }}</span>
						<app-copy-text *ngIf="workstation.serialNumber" [justButton]="true" [text]="workstation.serialNumber"></app-copy-text>
					</div>
				</div>
			</div>
		</div>
		<div class="flex-align-center border-light-grey-top" style="height: 50px;">
			<div class="flex-align-center pad-S w-50 border-box">
				<div class="flex-align-center gap-XS w-50">
					<img class="filter-grey" src="assets/icons/passcode-lock.svg" height="14px" alt="">
					<div class="flex-align-center">
						<span class="font-M fw-500 grey">{{ 'page.workstation.privateIp' | translate }}</span>
					</div>
				</div>
				<div class="flex-align-center flex-space-between w-50">
					<div [tooltip]="'page.workstation.noData' | translate" [tooltipDisabled]="workstation.privateIp !== null" [tooltipOffset]="5" class="info-chip flex-space-between flex-align-center">
						<span class="text-overflow-ellipsis">{{ workstation.privateIp || '-' }}</span>
						<app-copy-text *ngIf="workstation.privateIp" [justButton]="true" [text]="workstation.privateIp"></app-copy-text>
					</div>
				</div>
			</div>
			<div class="border-light-grey-left" style="height: 25px"></div>
			<div class="flex-align-center pad-S w-50 border-box">
				<div class="flex-align-center gap-XS w-50">
					<img class="filter-grey" src="assets/icons/passcode.svg" height="14px" alt="">
					<span class="font-M fw-500 grey">{{ 'page.workstation.externalIp' | translate }}</span>
				</div>
				<div class="flex-align-center flex-space-between w-50">
					<div [tooltip]="'page.workstation.noData' | translate" [tooltipDisabled]="workstation.externalIp !== null" [tooltipOffset]="5" class="info-chip flex-space-between flex-align-center">
						<span class="text-overflow-ellipsis">{{ workstation.externalIp || '-' }}</span>
						<app-copy-text *ngIf="workstation.externalIp" [justButton]="true" [text]="workstation.externalIp"></app-copy-text>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
